import React from 'react';
import PropTypes from 'prop-types';
import { iconBackBtn } from '~utils/svgIcons';
import { withRouter, Link } from 'react-router-dom';
import './style.scss';

function NavBackButton({ history, path = '/' }) {
    // console.log('+++history+++', history, history.location.pathname.split('/')[1]);
    if (history.length > 1) {
        return (
            <button
                type="button"
                className="nav-back-button"
                onClick={() =>
                    history.location.pathname.split('/')[1] === 'laws' ? history.push('/') : history.goBack()
                }
            >
                {iconBackBtn}
            </button>
        );
    }
    return (
        <Link className="nav-back-button" to={path}>
            {iconBackBtn}
        </Link>
    );
}

NavBackButton.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func,
        length: PropTypes.number,
    }).isRequired,
    path: PropTypes.string,
};

export default withRouter(NavBackButton);



// WEBPACK FOOTER //
// ./src/components/nav-back-button/index.js